import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useFormikContext, Field } from "formik";

const TestComment = () => {
  const { values } = useFormikContext();
  const [show, setShow] = useState(false);

const dateHeureRegex = new RegExp(
  "\\b(" +
    [
      "avant", "apres", "après",
      "urgent", "vite", "rapidement",
      "matin", "soir", "midi",
      "demain", "après-demain",
      "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche",
      "janvier", "février", "fevrier", "mars", "avril", "mai", "juin", "juillet",
      "août", "aout", "septembre", "octobre", "novembre", "décembre", "decembre",
      "\\d{1,2}h(?:\\d{2})?",      // heures style 9h, 9h30, 14h00
      "\\d{1,2}:\\d{2}",           // format 14:30
      "\\d{1,2}/\\d{1,2}(?:/\\d{2,4})?", // dates style 05/12, 5/12/2025
      "\\d{1,2}-\\d{1,2}(?:-\\d{2,4})?"  // dates style 05-12-2025
    ].join("|") +
  ")\\b",
  "i"
);

  return (
    <>
      <div className="form-floating mb-3">
        <Field
          as="textarea"
          name="comment"
          className="form-control backWhite"
          id="floatingComment"
          placeholder=""
          style={{ height: "100px" }}
          onBlur={(e) => {
            if (values.livraisonType === "flex" && dateHeureRegex.test(e.target.value)) {
              setShow(true);
            }
          }}
        />
        <label htmlFor="floatingComment" className="colorInput">
          Commentaire (optionnel)
        </label>
      </div>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Attention</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-3">
            Tu as choisi l’option <strong>Flex</strong>, mais ton commentaire mentionne une date ou une heure.
          </p>
          <p className="mb-3">
            Pour garantir une livraison à ce moment-là, merci de sélectionner l’option <strong>Planifiée</strong>.
          </p>
          <p>
            <strong>Option Flex :</strong> utilise-la quand tu es flexible sur la date et l’heure de livraison.
            On s’occupe de livrer ta commande dès que possible, sans engagement précis sur le timing.
          </p>
        </Modal.Body>

          <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TestComment;

